import _ from 'lodash'
import { useEffect, useState } from 'react'
import { HostingVersionCatalogue, ReleaseFamily, VersionDescriptor } from '@feedyou/schema'

type State = { releaseFamily: ReleaseFamily; version: string }

export function useSdkVersionFormState(
  catalogue: HostingVersionCatalogue,
  deployedVersion: VersionDescriptor
) {
  const [state, setState] = useState<State>(_.pick(deployedVersion, ['version', 'releaseFamily']))

  function updateState(patch: Partial<State>) {
    setState(prevState => {
      const newState = { ...prevState, ...patch }

      const availableVersionsForFamily = catalogue[newState.releaseFamily]?.versions
      const isVersionValidForFamily = availableVersionsForFamily?.some(
        v => v.version === newState.version
      )

      return isVersionValidForFamily
        ? newState
        : {
            ...newState,
            version: getDefaultVersion(newState.releaseFamily, catalogue, deployedVersion)
          }
    })
  }

  useEffect(
    () => updateState(_.pick(deployedVersion, ['version', 'releaseFamily'])),
    [deployedVersion.releaseFamily, deployedVersion.version]
  )

  return { state, updateState }
}

function getDefaultVersion(
  currentFamily: ReleaseFamily,
  catalogue: HostingVersionCatalogue,
  deployedVersion: VersionDescriptor
) {
  if (currentFamily === deployedVersion.releaseFamily) {
    return deployedVersion.version
  }

  const latestVersion = catalogue[currentFamily]?.latestVersion

  if (latestVersion) {
    return latestVersion
  }

  if (catalogue[currentFamily]?.versions?.some(v => v.version === 'latest')) {
    return 'latest'
  }

  return ''
}
